import React from 'react';
import Row from "@amzn/meridian/esm/components/row";
import Column from "@amzn/meridian/esm/components/column";
import InfoCard, { INFO_CARD_VARIANT } from "../../../../components/InfoCard";
import { FEEDBACK_PAGE } from "../../../../constants";

/**
 * HelpTabInClient Component
 *
 * Displays the help tab content for the client interface, including the feedback, wiki and
 * policy InfoCards in a structured layout with specific spacing and alignment.
 *
 * @returns {JSX.Element} Help tab content with feedback and wiki cards for the client interface
 */
const HelpTabInClient = () => {
    return (
        <Column spacing="450" spacingInset="600 none none none" alignmentHorizontal="start">
            <Row spacing="450" alignmentVertical="top">
                <InfoCard variant={INFO_CARD_VARIANT.FEEDBACK} page={FEEDBACK_PAGE.IN_CLIENT_FEEDBACK_TAB} />
                <InfoCard variant={INFO_CARD_VARIANT.WIKI} />
            </Row>
            <InfoCard variant={INFO_CARD_VARIANT.POLICY} />
        </Column>
    );
};

export default HelpTabInClient;
